import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';
import { SharedConsts } from '../constants';

declare var Stripe: any;
@Injectable({
  providedIn: 'root'
})
export class CustomValidatorService {

  constructor() { }

  public urlValidator(control: FormControl) {
    if (!control.value || !control.value.trim()) { return null; }
    const isValid = SharedConsts.URL_PATTERN.test(control.value.toLowerCase());
    return isValid ? null : { url: true };
  }

  public spaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').toString().trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { required: true };
  }

  public passwordValidator(control: FormControl) {
    if (!control.value || !control.value.trim()) { return null; }
    const isValid = SharedConsts.PASSWORD_PATTERN.test(control.value.toLowerCase());
    return isValid ? null : { password: true };
  }

  public emailValidator(control: FormControl) {
    if (!control.value || !control.value.trim()) { return null; }
    const isValid = SharedConsts.EMAIL_PATTERN.test(control.value.toLowerCase());
    return isValid ? null : { email: true };
  }


}
